import { Position, Toaster } from "@blueprintjs/core";
 
export default Toaster.create({
    className: "app-toaster",
    position: Position.TOP,
});
